var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"select-container"},_vm.$listeners),[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked}}),_c('span',{staticClass:"label",domProps:{"textContent":_vm._s(_vm.label)}})])}
var staticRenderFns = []

export { render, staticRenderFns }